import * as Yup from 'yup'
import { Form,Row,Col } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';

export const Schema = (settings) => Yup.object().shape({
    salaryRequest: Yup.number()
        .typeError("Nur Zahlenwerte ohne Sonderzeichen")
        .positive("Nur positive Zahlen")
        .integer("Nur ganze Zahlen")
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val < 999999999;
            return true;
        })
        .required("Angabe ist erforderlich"),
    workTime: Yup.number()
        .typeError("Nur Zahlenwerte ohne Sonderzeichen")
        .positive("Nur positive Zahlen")
        .integer("Nur ganze Zahlen")
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val < 999999999;
            return true;
        })
        .required("Angabe ist erforderlich"),        
});

export const SalaryRequestSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
        <Row className="mb-3">
            <Form.Group as={Col} className="mb-3" controlId="formSalaryRequest">
                <Form.Label>Gehaltsvorstellung pro Jahr*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Jährliche Gehaltsvorstellung eingeben"
                    type="text"
                    name="salaryRequest"
                    value={values.salaryRequest || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.salaryRequest && !errors.salaryRequest}
                    isInvalid={touched.salaryRequest && errors.salaryRequest}
                    maxLength={9}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.salaryRequest}
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} className="mb-3" controlId="formWorkTime">
                <Form.Label>Gewünschte Arbeitszeit(%)*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Gewünschte Arbeitszeit in Prozent"
                    type="text"
                    name="workTime"
                    value={values.workTime || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.workTime && !errors.workTime}
                    isInvalid={touched.workTime && errors.workTime}
                    maxLength={3}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.workTime}
                </Form.Control.Feedback>
            </Form.Group>
        </Row>
        </>
    );
};